import { Alert, Box, FormField, FormHelp, Heading, Input, Label, Paragraph } from '@zillow/constellation-10';
import Image from 'next/image';
import FlexibleLandlordIcon from '../../../assets/FlexibleLandlord.svg';
import BenefitsAccordion from './BenefitsAccordion';

type RequestPaymentsBodyProps = {
  emailSendError: boolean;
  email: string;
  onEmailChange: (email: string) => void;
  emailValidationError?: string;
};

const CONTENT = {
  HEADING: 'Ask your landlord to set up Zillow payments',
  DESCRIPTION_LINE_1:
    "It's easy. We'll send an email to your landlord, explaining the benefits of Zillow payments and how to set up your rental property.",
  DESCRIPTION_LINE_2: "If they choose to collect rent with Zillow, you'll get access to rent reporting for free.",
  LANDLORD_EMAIL_LABEL: "Landlord's email",
  ERROR_MESSAGE: 'We were unable to send your request for Zillow payments. Please try again.',
} as const;

const RequestPaymentsBody = ({
  emailSendError,
  email,
  onEmailChange,
  emailValidationError,
}: RequestPaymentsBodyProps) => {
  return (
    <>
      {emailSendError && (
        <Alert tone="critical" css={{ marginBottom: 'looser' }}>
          <Alert.Body>
            <Paragraph data-testid="error-message">{CONTENT.ERROR_MESSAGE}</Paragraph>
          </Alert.Body>
        </Alert>
      )}
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'left',
          marginRight: 'default',
          flexShrink: 0,
          marginBottom: 'default',
        }}
      >
        <Image src={FlexibleLandlordIcon} alt="Flexible landlord" width={120} height={120} />
      </Box>

      <Heading level={2} textStyle="heading-xs" css={{ marginBottom: 'default' }}>
        {CONTENT.HEADING}
      </Heading>

      <Paragraph css={{ marginBottom: 'default' }}>{CONTENT.DESCRIPTION_LINE_1}</Paragraph>

      <Paragraph css={{ marginBottom: 'loose' }}>{CONTENT.DESCRIPTION_LINE_2}</Paragraph>

      <Box css={{ marginBottom: 'loose' }}>
        <FormField
          label={<Label>{CONTENT.LANDLORD_EMAIL_LABEL}</Label>}
          control={<Input type="email" onChange={(e) => onEmailChange(e.target.value)} value={email} />}
          required
          description={emailValidationError && <FormHelp>{emailValidationError}</FormHelp>}
          error={!!emailValidationError}
        />
      </Box>
      <BenefitsAccordion />
    </>
  );
};

export default RequestPaymentsBody;
